export enum SortBy {
    NAME,
    LAST_LOG_IN
}
